module.exports = __webpack_public_path__ + "app-static/img/btn.82a0e639.png";